import { render, staticRenderFns } from "./wxxq.vue?vue&type=template&id=024bbedd&scoped=true&"
import script from "./wxxq.vue?vue&type=script&lang=js&"
export * from "./wxxq.vue?vue&type=script&lang=js&"
import style0 from "./wxxq.vue?vue&type=style&index=0&id=024bbedd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024bbedd",
  null
  
)

export default component.exports